import login from "./login";
export default login;